import { ISiteUserInfo } from '../../ts/models/ISiteUserInfo';
import React = require('react');
import { Formik, FormikProps } from 'formik';

import { Messages } from '../../codegen/Localize';
import { FormikCheckbox } from '../../commonInfra/components/FormikCheckbox';
import { UserSettingsStyle } from '../styles/UserSettingsStyle';
import _ = require('underscore');
import { IError } from '../../httpClient/serverApi/types/IError';
import { IResult } from '../../httpClient/serverApi/types/IResponse';
import { IServerUserInfo } from '../../ts/models/IServerUserInfo';
import { ToasterService, ToastType } from '../../ts/services/ToasterService';
import { UserSettings } from '../services/resources/UserSettings';
import { InlineCancelAndSaveButtons } from './UserSettingEditButtons';

export type MarkAnimationProps = {
    userHasNoSiteId: boolean;
    siteUser: ISiteUserInfo;
    serverUser: IServerUserInfo;
}

export interface MarkAnimationField {
    markAnimationSetting: boolean;
}

function showButtons(formik: FormikProps<MarkAnimationField>, markAnimationSetting: boolean) {
  if (!formik.touched || !formik.isValid || formik.isSubmitting || _.isEqual(formik.values.markAnimationSetting, markAnimationSetting)) {
    return false;
  }
  return true;
}

export function MarkAnimationSetting(props: MarkAnimationProps): JSX.Element {
  const [currentMarkAnimation, setCurrentMarkAnimation] = React.useState(false);

  function handleSubmit(values: MarkAnimationField, siteUser: ISiteUserInfo) {
    UserSettings.updateMarkAnimationSetting(
      siteUser.id, values.markAnimationSetting
    ).then((result: IResult) => {
      setCurrentMarkAnimation(values.markAnimationSetting);
      ToasterService.instance.pop({ type: ToastType.Success, text: Messages.settingsUpdateSuccess() });
    }).catch((error: IError) => {
      ToasterService.instance.pop({ type: ToastType.Error, text: Messages.settingsUpdateFailure() });
    });
  }

  React.useEffect(
    () => {
      UserSettings.getMarkAnimationSetting(props.serverUser.id)
      .then((result: boolean) => {
        setCurrentMarkAnimation(result);
      }).catch((error: IError) => { });
    },
    // This deps array was noncompliant before we enabled the lint rule. If you're here, please consider fixing it! See TFS 1257824
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  );

  return (
    <Formik
      initialValues={{ markAnimationSetting: currentMarkAnimation }}
      onSubmit={(values: MarkAnimationField) => handleSubmit(values, props.siteUser)}
      enableReinitialize={true}
    >
      {
        (formik: FormikProps<MarkAnimationField>) => (
          <form onSubmit={formik.handleSubmit}>
            <table>
              <tbody className={UserSettingsStyle.tbody}>
                <tr data-tb-test-id="userSettings-mark-animation">
                  <td className={UserSettingsStyle.labelText}>
                    {Messages.markAnimationSettingSection()}</td>
                  <td className={UserSettingsStyle.detailsValue}>
                    {Messages.markAnimationUserSettingDetail()}</td>
                </tr>
                <tr>
                <td className={UserSettingsStyle.labelText}></td>
                <td className={UserSettingsStyle.detailsValue}>
                  <FormikCheckbox
                  containerStyle={{marginLeft: 0}}
                  testId='Mark-Animation-Enabled'
                  name='markAnimationSetting'
                  disabled={props.userHasNoSiteId}
                  label={Messages.markAnimationUserSettingEnable()}/>
                </td>
                </tr>
                {
                  showButtons(formik, currentMarkAnimation) &&
                  <InlineCancelAndSaveButtons
                  testId='Mark-Animation'
                  formik={formik}
                  />
                }
               </tbody>
            </table>
          </form>
        )
      }
    </Formik>
  );

}